import { buildDispatchable } from '../../../actions/_action-utilities';
import { clearAllFilters, getCaseFilter, getDictionary, getShowOrderNumber, getTenantFilter, list, navigateDetail } from '../../../actions/cases.action';
import { onDetailNavigate, onListNavigateGenerator } from '../../utils/view-utils';
import { commonEnums } from '@codametrix/ui-common';
import { HTTPMethodType } from '../../../components/data-grid/data-grid-utils';
const { FilterKeys } = commonEnums;
export const mapStateToProps = function(state) {
    const { cases, ui } = state;
    var filterForms = cases.criteriaFilter.filterForms;
    if (ui.context.activeContext && ui.context.activeContext.parentLevel > 1) {
        filterForms = cases.criteriaFilter.filterForms.filter((form)=>{
            return form.key !== FilterKeys.TENANT;
        });
    }
    const casesFiltered = {
        ...cases,
        criteriaFilter: {
            ...cases.criteriaFilter,
            filterForms: filterForms
        }
    };
    return {
        ...casesFiltered,
        activeOrgId: ui.context.activeContext?.organizationId || -1,
        serviceLine: ui.serviceLine
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        onNavigate: onListNavigateGenerator(dispatch),
        onSelection: (caseInstance)=>{
            runDispatchable(()=>{
                onDetailNavigate(dispatch);
                return dispatch(navigateDetail(caseInstance));
            });
        },
        getDictionary: (params)=>{
            runDispatchable(()=>{
                return dispatch(getDictionary(params));
            });
        },
        getStatuses: (params)=>{
            runDispatchable(()=>{
                return dispatch(getCaseFilter(params));
            });
        },
        getTenants: (params)=>{
            runDispatchable(()=>{
                return dispatch(getTenantFilter(params));
            });
        },
        list: (options)=>{
            runDispatchable(()=>{
                return dispatch(list(options));
            });
        },
        clearFilters: ()=>{
            runDispatchable(()=>{
                return dispatch(clearAllFilters());
            });
        },
        showOrderNumber: (key, tenantId)=>{
            runDispatchable(()=>{
                return dispatch(getShowOrderNumber({
                    key,
                    tenantId
                }));
            });
        }
    };
};
export const caseListEndPoint = (serviceLineConfigPath, caseListVersion)=>{
    const caseListEnpPointPath = `/api/cases/${serviceLineConfigPath.toUpperCase()}/caseinstance/list/${caseListVersion}`;
    const caseListEndPoint = {
        endPoint: caseListEnpPointPath,
        HTTPMethodType: HTTPMethodType.POST
    };
    return caseListEndPoint;
};
